// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.identityverification.CometUserIdentityVerificationCategory

export enum CometUserIdentityVerificationCategory {
  DOCUMENT_BIOMETRIC = 'DOCUMENT_BIOMETRIC',
}

export const CometUserIdentityVerificationCategory_values = [
  CometUserIdentityVerificationCategory.DOCUMENT_BIOMETRIC,
] as const;
